import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Customer } from '@/types';
import { useDeleteCustomerMutation } from '@/services';

export interface DeleteCustomerProps extends DialogProps {
  customer: Customer;
  onClose(): void;
}

const DeleteCustomer: React.FC<DeleteCustomerProps> = ({ customer, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCustomer, deleteCustomerResponse] = useDeleteCustomerMutation();

  async function handleDeleteCustomer() {
    try {
      await deleteCustomer(customer).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{customer?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{customer?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteCustomerResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteCustomerResponse.isLoading} onClick={handleDeleteCustomer}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCustomer;
